import { render } from "./Telegram.vue?vue&type=template&id=06febf96"
const script = {}
script.render = render

export default script